import configFile from '../assets/config.json'

let config = null;
export default class ConfigService {
	getConfig() {
		if (config == null || !config.environment) {
			config = configFile;
		}
		if (config.environment == "PROD")
			return config.configProd;
		return config.configDev;
	}
}